import { defineComponent as N, watchEffect as T, inject as S, computed as g, watch as k, toRef as V, nextTick as y, h as _ } from "vue";
import { createTmOptions as x } from "./ghl-ui.es867.js";
import { popselectInjectionKey as R } from "./ghl-ui.es1074.js";
import U from "./ghl-ui.es1376.js";
import { warn as A } from "./ghl-ui.es853.js";
import F from "./ghl-ui.es854.js";
import B from "./ghl-ui.es855.js";
import O from "./ghl-ui.es1076.js";
import { createTreeMate as I } from "./ghl-ui.es871.js";
import { useThemeClass as E } from "./ghl-ui.es857.js";
import L from "./ghl-ui.es873.js";
import { happensIn as h } from "./ghl-ui.es944.js";
import { call as d } from "./ghl-ui.es876.js";
import { keysOf as $ } from "./ghl-ui.es924.js";
const w = {
  multiple: Boolean,
  value: {
    type: [String, Number, Array],
    default: null
  },
  cancelable: Boolean,
  options: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: "medium"
  },
  scrollable: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onMouseenter: Function,
  onMouseleave: Function,
  renderLabel: Function,
  showCheckmark: {
    type: Boolean,
    default: void 0
  },
  nodeProps: Function,
  virtualScroll: Boolean,
  // deprecated
  onChange: [Function, Array]
}, oe = $(w), te = N({
  name: "PopselectPanel",
  props: w,
  setup(t) {
    process.env.NODE_ENV !== "production" && T(() => {
      t.onChange !== void 0 && A("popselect", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const o = S(R), {
      mergedClsPrefixRef: n,
      inlineThemeDisabled: m
    } = F(t), M = B("Popselect", "-pop-select", U, O, o.props, n), f = g(() => I(t.options, x("value", "children")));
    function u(e, r) {
      const {
        onUpdateValue: s,
        "onUpdate:value": l,
        onChange: a
      } = t;
      s && d(s, e, r), l && d(l, e, r), a && d(a, e, r);
    }
    function P(e) {
      b(e.key);
    }
    function C(e) {
      !h(e, "action") && !h(e, "empty") && !h(e, "header") && e.preventDefault();
    }
    function b(e) {
      const {
        value: {
          getNode: r
        }
      } = f;
      if (t.multiple)
        if (Array.isArray(t.value)) {
          const s = [], l = [];
          let a = !0;
          t.value.forEach((v) => {
            if (v === e) {
              a = !1;
              return;
            }
            const c = r(v);
            c && (s.push(c.key), l.push(c.rawNode));
          }), a && (s.push(e), l.push(r(e).rawNode)), u(s, l);
        } else {
          const s = r(e);
          s && u([e], [s.rawNode]);
        }
      else if (t.value === e && t.cancelable)
        u(null, null);
      else {
        const s = r(e);
        s && u(e, s.rawNode);
        const {
          "onUpdate:show": l,
          onUpdateShow: a
        } = o.props;
        l && d(l, !1), a && d(a, !1), o.setShow(!1);
      }
      y(() => {
        o.syncPosition();
      });
    }
    k(V(t, "options"), () => {
      y(() => {
        o.syncPosition();
      });
    });
    const p = g(() => {
      const {
        self: {
          menuBoxShadow: e
        }
      } = M.value;
      return {
        "--n-menu-box-shadow": e
      };
    }), i = m ? E("select", void 0, p, o.props) : void 0;
    return {
      mergedTheme: o.mergedThemeRef,
      mergedClsPrefix: n,
      treeMate: f,
      handleToggle: P,
      handleMenuMousedown: C,
      cssVars: m ? void 0 : p,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t;
    return (t = this.onRender) === null || t === void 0 || t.call(this), _(L, {
      clsPrefix: this.mergedClsPrefix,
      focusable: !0,
      nodeProps: this.nodeProps,
      class: [`${this.mergedClsPrefix}-popselect-menu`, this.themeClass],
      style: this.cssVars,
      theme: this.mergedTheme.peers.InternalSelectMenu,
      themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
      multiple: this.multiple,
      treeMate: this.treeMate,
      size: this.size,
      value: this.value,
      virtualScroll: this.virtualScroll,
      scrollable: this.scrollable,
      renderLabel: this.renderLabel,
      onToggle: this.handleToggle,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseenter,
      onMousedown: this.handleMenuMousedown,
      showCheckmark: this.showCheckmark
    }, {
      header: () => {
        var o, n;
        return ((n = (o = this.$slots).header) === null || n === void 0 ? void 0 : n.call(o)) || [];
      },
      action: () => {
        var o, n;
        return ((n = (o = this.$slots).action) === null || n === void 0 ? void 0 : n.call(o)) || [];
      },
      empty: () => {
        var o, n;
        return ((n = (o = this.$slots).empty) === null || n === void 0 ? void 0 : n.call(o)) || [];
      }
    });
  }
});
export {
  te as default,
  oe as panelPropKeys,
  w as panelProps
};
